(function () {
  function init() {
    var root = document.getElementById('lp-root');
    if (!root) return;

    var currency = root.getAttribute('data-currency') || 'USD';
    var lang = root.getAttribute('data-lang') || (document.documentElement.lang || 'es-UY');
    var continueUrl = root.getAttribute('data-continue-url') || '/';

    // ========== CONFIGURACIÓN SUSCRIPCIÓN ==========
    var FREE_PRODUCT_VARIANT_ID = 10120764424468;

    // Discount codes creados en Shopify Admin
    var DISCOUNT_CODES = {
      5:  'ACEITE5',
      7:  'ACEITE7',
      10: 'ACEITE10',
      12: 'ACEITE12',
      15: 'ACEITE15'
    };

    // ========== ÚNICA TABLA DE REGLAS (unificada) ==========
    // Formato: tipo × modo × cantidad → descuento % + envío
    var RULES = {
      '3l': {
        sin: { // Compra única
          1: { discount: 0,  shipping: 'paid', label: '1 bidón' },
          2: { discount: 0,  shipping: 'free', label: '2 bidones' },
          3: { discount: 5,  shipping: 'free', label: '3 bidones' },   // ACEITE5
          4: { discount: 10, shipping: 'free', label: '4 bidones' }    // ACEITE10
        },
        con: { // Suscripción (+10% adicional en el precio)
          1: { discount: 7,  shipping: 'paid', label: '1 bidón' },     // ACEITE7
          2: { discount: 7,  shipping: 'free', label: '2 bidones' },
          3: { discount: 10, shipping: 'free', label: '3 bidones' },
          4: { discount: 12, shipping: 'free', label: '4 bidones' }    // ACEITE12
        }
      },
      '5l': {
        sin: {
          1: { discount: 0,  shipping: 'free', label: '1 bidón' },
          2: { discount: 5,  shipping: 'free', label: '2 bidones' },   // ACEITE5
          3: { discount: 10, shipping: 'free', label: '3 bidones' },   // ACEITE10
          4: { discount: 12, shipping: 'free', label: '4 bidones' }    // ACEITE12
        },
        con: {
          1: { discount: 7,  shipping: 'free', label: '1 bidón' },     // ACEITE7
          2: { discount: 10, shipping: 'free', label: '2 bidones' },   // ACEITE10
          3: { discount: 12, shipping: 'free', label: '3 bidones' },   // ACEITE12
          4: { discount: 15, shipping: 'free', label: '4 bidones' }    // ACEITE15
        }
      }
    };

    // ========== ESTADO GLOBAL ==========
    var state = {
      basePrice: 0,
      comparePrice: 0,
      qty: 1,
      variantType: '3l',    // '3l', '5l' u 'other'
      mode: 'onetime',      // 'onetime' o 'sub'
      subDiscount: 0.10     // 10% adicional por suscripción (se aplica al precio, no como código)
    };

    // ========== HELPERS ==========
    function moneyFromCents(cents) {
      cents = parseInt(cents || '0', 10) || 0;
      try {
        var fmt = new Intl.NumberFormat(lang, { style: 'currency', currency: currency });
        return fmt.format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function detectVariantType(title) {
      var t = (title || '').toLowerCase();
      if (t.includes('3') || t.includes('3l') || t.includes('3 litros') || t.includes('3000ml') || t.includes('3000 ml')) {
        return '3l';
      }
      if (t.includes('5') || t.includes('5l') || t.includes('5 litros') || t.includes('5000ml') || t.includes('5000 ml')) {
        return '5l';
      }
      return 'other';
    }

    // ========== REGLA ACTIVA (única fuente de verdad) ==========
    function getActiveRule() {
      var t = state.variantType === '5l' ? '5l' : '3l';
      var m = state.mode === 'sub' ? 'con' : 'sin';
      var q = Math.min(state.qty, 4);
      return (RULES[t] && RULES[t][m] && RULES[t][m][q]) || { discount: 0, shipping: 'paid', label: state.qty + ' bidones' };
    }

    // ========== CÁLCULO DE PRECIOS (corregido) ==========
    function calculatePrices() {
      var rule = getActiveRule();
      var qtyDiscountPercent = rule.discount / 100; // Descuento por cantidad (para el código)
      
      var subtotal = state.basePrice * state.qty;
      var compareTotal = state.comparePrice * state.qty;
      
      // Aplicar descuento por cantidad
      var afterQtyDiscount = subtotal * (1 - qtyDiscountPercent);
      
      // Si es suscripción, aplicar 10% adicional (esto es separado del código de descuento)
      var finalPrice = state.mode === 'sub'
        ? afterQtyDiscount * (1 - state.subDiscount)
        : afterQtyDiscount;
      
      return {
        final: Math.round(finalPrice),
        compare: compareTotal > finalPrice ? compareTotal : 0,
        subtotal: subtotal,
        qtyDiscountPercent: rule.discount, // ← Este es el % que se muestra y va al código
        qtyDiscountAmount: subtotal * qtyDiscountPercent,
        subDiscountAmount: state.mode === 'sub' ? (afterQtyDiscount * state.subDiscount) : 0,
        rule: rule
      };
    }

    // ========== ACTUALIZAR BADGES DE CANTIDAD ==========
    function updateQtyBadges() {
      var t = state.variantType === '5l' ? '5l' : '3l';
      var m = state.mode === 'sub' ? 'con' : 'sin';
      
      // Actualizar ambos contenedores (3l y 5l)
      ['3l', '5l'].forEach(function(type) {
        var activeOpts = root.querySelector('.lp-qty-options[data-type="' + type + '"]');
        if (!activeOpts) return;
        
        activeOpts.querySelectorAll('.lp-qty-tile').forEach(function (tile) {
          var q = Math.min(parseInt(tile.getAttribute('data-qty'), 10), 4);
          var r = (RULES[type][m] && RULES[type][m][q]) || { discount: 0, shipping: 'paid' };
          var badge = tile.querySelector('.lp-qty-badge');
          if (!badge) return;
          
          var parts = [];
          if (r.discount > 0)        parts.push('-' + r.discount + '%');
          if (r.shipping === 'free') parts.push('Envío gratis');
          
          if (parts.length) {
            badge.textContent = parts.join(' + ');
            badge.style.display = '';
          } else {
            badge.textContent = '';
            badge.style.display = 'none';
          }
        });
      });
    }

    // ========== URL CHECKOUT CON DESCUENTO ==========
    function buildCheckoutUrl() {
      var rule = getActiveRule();
      var code = rule.discount > 0 ? DISCOUNT_CODES[rule.discount] : null;
      return code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    }

    // ========== PRODUCTO GRATIS PARA SUSCRIPCIÓN ==========
    function addFreeProduct() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ 
            id: FREE_PRODUCT_VARIANT_ID, 
            quantity: 1, 
            properties: { _free_gift: 'true', Tipo: 'Regalo suscripcion' } 
          }]
        })
      });
    }

    // ========== GUARDAR DATOS DE SUSCRIPTOR ==========
    function saveSubscriberData() {
      try {
        var rule = getActiveRule();
        localStorage.setItem('lp_pending_subscription', JSON.stringify({
          variantType: state.variantType,
          qty: state.qty,
          discount: rule.discount,
          shipping: rule.shipping,
          date: new Date().toISOString().split('T')[0]
        }));
      } catch(e) {}
    }

    // ========== ELEMENTOS DOM ==========
    var mainImg = document.getElementById('lpMainImg');
    var thumbs = root.querySelectorAll('.lp-thumb');
    
    var vTiles = root.querySelectorAll('#lpVariantTiles .lp-tile');
    var variantInput = document.getElementById('lpVariantId');
    
    var qtyContainer = document.getElementById('lpQtyTiles');
    var qtyInput = document.getElementById('lpQtyInput');
    var shippingInput = document.getElementById('lpShippingMethod');
    var discountInput = document.getElementById('lpDiscountApplied');
    
    var priceNow = document.getElementById('lpPriceNow');
    var priceCompare = document.getElementById('lpPriceCompare');
    var oneTime = document.getElementById('lpOneTimePrice');
    var subPrice = document.getElementById('lpSubPrice');
    var btn = document.getElementById('lpCtaBtn');
    
    var modes = root.querySelectorAll('#lpPurchase .lp-radio');
    var modeInput = document.getElementById('lpPurchaseMode');
    
    var tabBtns = root.querySelectorAll('.lp-tab-btn');
    var panels = {
      details: document.getElementById('lpTab-details'),
      harvest: document.getElementById('lpTab-harvest'),
      uses: document.getElementById('lpTab-uses'),
      refills: document.getElementById('lpTab-refills')
    };
    
    var refillWrap = document.getElementById('lpRefillGrid');
    var refillOptions = refillWrap ? refillWrap.querySelectorAll('.lp-refill-option') : [];

    // ========== ACTUALIZAR UI DE PRECIOS ==========
    function updateAllPrices() {
      var prices = calculatePrices();
      var rule = prices.rule;
      
      // Precio principal con badges
      if (priceNow) {
        var html = moneyFromCents(prices.final);
        
        // Badge de descuento por cantidad (el que va al código)
        if (rule.discount > 0) {
          html += '<span class="lp-discount-badge">-' + rule.discount + '%</span>';
        }
        
        // Badge de envío gratis
        if (rule.shipping === 'free') {
          html += '<span class="lp-shipping-badge">Envío gratis</span>';
        }
        
        priceNow.innerHTML = html;
      }
      
      // Precio tachado (compare_at_price)
      if (priceCompare) {
        if (prices.compare > prices.final) {
          priceCompare.textContent = moneyFromCents(prices.compare);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      
      // Precio en modo compra única
      if (oneTime) {
        var oneTimeTotal = state.basePrice * state.qty * (1 - (rule.discount / 100));
        oneTime.textContent = moneyFromCents(Math.round(oneTimeTotal));
      }
      
      // Precio en modo suscripción
      if (subPrice) {
        var subTotal = state.basePrice * state.qty * (1 - (rule.discount / 100)) * (1 - state.subDiscount);
        subPrice.textContent = moneyFromCents(Math.round(subTotal));
      }
      
      // Botón CTA
      if (btn && !btn.disabled) {
        var btnText = state.mode === 'sub' ? 'SUSCRIBIRSE' : 'AGREGAR AL CARRITO';
        var shippingText = rule.shipping === 'free' ? ' + ENVÍO GRATIS' : '';
        btn.innerHTML = btnText + ' — ' + moneyFromCents(prices.final) + shippingText;
      }
      
      // Inputs ocultos del formulario
      if (shippingInput) {
        shippingInput.value = rule.shipping === 'free' ? 'Gratis' : 'Pago';
      }
      if (discountInput) {
        discountInput.value = rule.discount + '%'; // ← AHORA SÍ COINCIDE CON EL CÓDIGO
      }
      
      // Actualizar precios de refill
      refillOptions.forEach(function(opt) {
        var priceEl = opt.querySelector('.lp-refill-price');
        if (priceEl) {
          var basePrice = parseInt(priceEl.getAttribute('data-base-price') || '0', 10);
          if (basePrice > 0) {
            var refillTotal = basePrice * state.qty * (1 - (rule.discount / 100));
            if (state.mode === 'sub') {
              refillTotal = refillTotal * (1 - state.subDiscount);
            }
            priceEl.textContent = moneyFromCents(Math.round(refillTotal));
          }
        }
      });

      // Actualizar badges de cantidad
      updateQtyBadges();
    }

    // ========== SWITCH DE OPCIONES DE CANTIDAD ==========
    function switchQuantityOptions(type) {
      if (!qtyContainer) return;

      var options = qtyContainer.querySelectorAll('.lp-qty-options');
      options.forEach(function (opt) { opt.style.display = 'none'; });

      var activeType = (type === '5l') ? '5l' : '3l';
      var active = qtyContainer.querySelector('.lp-qty-options[data-type="' + activeType + '"]');
      if (active) active.style.display = '';

      qtyContainer.setAttribute('data-current-type', activeType);
      state.variantType = activeType;

      var firstTile = active ? active.querySelector('.lp-qty-tile.is-active') || active.querySelector('.lp-qty-tile') : null;
      if (firstTile) {
        setActiveQty(firstTile, activeType);
      } else {
        state.qty = 1;
        if (qtyInput) qtyInput.value = '1';
        updateAllPrices();
      }
    }

    // ========== GALERÍA ==========
    if (thumbs && thumbs.length && mainImg) {
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          var url = b.getAttribute('data-large');
          if (!url) return;
          mainImg.style.opacity = '0.0';
          window.setTimeout(function () {
            mainImg.src = url;
            mainImg.style.opacity = '1';
          }, 140);
        });
      });
    }

    // ========== REFILL POR VARIANTE ==========
    function syncRefillByVariantTitle(title) {
      if (!refillWrap || !refillOptions || !refillOptions.length) return;
      var t = (title || '').toLowerCase();
      var is250 = t.indexOf('250') !== -1;
      var is1l = (t.indexOf('1l') !== -1) || (t.indexOf('1 l') !== -1) || (t.indexOf('1 litro') !== -1) || (t.indexOf('1000') !== -1);
      
      refillOptions.forEach(function (opt) {
        opt.classList.remove('is-disabled');
        var input = opt.querySelector('input');
        if (input) input.disabled = false;
      });
      
      if (is250 && !is1l) {
        var o1l = refillWrap.querySelector('[data-refill="refill-1l"]');
        if (o1l) {
          o1l.classList.add('is-disabled');
          var i1l = o1l.querySelector('input');
          if (i1l) i1l.disabled = true;
        }
      } else if (is1l && !is250) {
        var o250 = refillWrap.querySelector('[data-refill="refill-250"]');
        if (o250) {
          o250.classList.add('is-disabled');
          var i250 = o250.querySelector('input');
          if (i250) i250.disabled = true;
        }
      }
    }

    if (refillOptions && refillOptions.length) {
      refillOptions.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('is-disabled')) return;
          refillOptions.forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var input = opt.querySelector('input');
          if (input) input.checked = true;
        });
      });
    }

    // ========== VARIANTES ==========
    function setActiveVariant(tile) {
      vTiles.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-checked', 'false');
        t.setAttribute('tabindex', '0');
      });
      tile.classList.add('is-active');
      tile.setAttribute('aria-checked', 'true');
      
      var titleEl = tile.querySelector('.lp-tile-title');
      var titleText = titleEl ? titleEl.textContent : '';
      
      state.variantType = detectVariantType(titleText);
      switchQuantityOptions(state.variantType);
      
      state.basePrice = parseInt(tile.getAttribute('data-price') || '0', 10);
      state.comparePrice = parseInt(tile.getAttribute('data-compare') || '0', 10);
      
      var id = tile.getAttribute('data-variant-id');
      var available = tile.getAttribute('data-available') === 'true';
      
      if (variantInput && id) variantInput.value = id;
      
      if (btn) {
        if (!available) {
          btn.disabled = true;
          btn.textContent = 'SIN STOCK';
          btn.style.opacity = '0.65';
          btn.style.cursor = 'not-allowed';
        } else {
          btn.disabled = false;
          btn.style.opacity = '';
          btn.style.cursor = '';
        }
      }
      
      syncRefillByVariantTitle(titleText);
      updateAllPrices();
    }

    vTiles.forEach(function (tile) {
      tile.addEventListener('click', function () { setActiveVariant(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveVariant(tile); }
      });
    });

    var firstVariant = root.querySelector('#lpVariantTiles .lp-tile.is-active');
    if (firstVariant) {
      var firstTitle = firstVariant.querySelector('.lp-tile-title');
      state.variantType = detectVariantType(firstTitle ? firstTitle.textContent : '');
      state.basePrice = parseInt(firstVariant.getAttribute('data-price') || '0', 10);
      state.comparePrice = parseInt(firstVariant.getAttribute('data-compare') || '0', 10);
      switchQuantityOptions(state.variantType);
    }

    // ========== CANTIDADES (TILES) ==========
    function setActiveQty(tile, forcedType) {
      // Quitar active de todos los tiles
      var allTiles = root.querySelectorAll('.lp-qty-tile');
      allTiles.forEach(function (t) { t.classList.remove('is-active'); });
      
      // Activar el seleccionado
      tile.classList.add('is-active');
      
      // Actualizar estado
      state.qty = parseInt(tile.getAttribute('data-qty') || '1', 10);
      if (qtyInput) qtyInput.value = String(state.qty);
      
      updateAllPrices();
    }

    function setupQtyListeners() {
      var allQtyTiles = root.querySelectorAll('.lp-qty-tile');
      allQtyTiles.forEach(function (tile) {
        tile.addEventListener('click', function () { setActiveQty(tile); });
        tile.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveQty(tile); }
        });
      });
    }
    setupQtyListeners();

    // ========== MODO DE COMPRA ==========
    function setMode(el) {
      modes.forEach(function (m) { m.classList.remove('is-active'); });
      el.classList.add('is-active');
      state.mode = el.getAttribute('data-mode');
      if (modeInput) modeInput.value = (state.mode === 'sub') ? 'Subscription' : 'One time';
      
      updateAllPrices();
    }

    modes.forEach(function (m) {
      m.addEventListener('click', function () { setMode(m); });
      m.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setMode(m); }
      });
    });

    // ========== TABS ==========
    function showTab(key) {
      tabBtns.forEach(function (b) {
        var is = b.getAttribute('data-tab') === key;
        b.classList.toggle('is-active', is);
        b.setAttribute('aria-selected', is ? 'true' : 'false');
      });
      Object.keys(panels).forEach(function (k) {
        if (!panels[k]) return;
        panels[k].hidden = (k !== key);
      });
    }

    tabBtns.forEach(function (b) {
      b.addEventListener('click', function () { showTab(b.getAttribute('data-tab')); });
    });

    // ========== POPUP AGREGADO AL CARRITO ==========
    var form = document.getElementById('lpForm');
    var pop = document.getElementById('lpCartPop');

    function openAddedPopup() {
      if (!pop) return;
      pop.hidden = false;
    }

    function closeAddedPopup() {
      if (!pop) return;
      pop.hidden = true;
    }

    if (pop) {
      var closers = pop.querySelectorAll('[data-close]');
      closers.forEach(function (el) {
        el.addEventListener('click', function () { closeAddedPopup(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) closeAddedPopup();
      });
    }

    // ========== SUBMIT DEL FORMULARIO ==========
    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (btn && btn.disabled) return;
        e.preventDefault();

        var prevHtml = btn ? btn.innerHTML : '';
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = 'AGREGANDO…';
        }

        var fd = new FormData(form);

        // Paso 1: agregar producto principal
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        })
        .then(function () {
          // Paso 2: si es suscripción, agregar producto gratis
          if (state.mode === 'sub') {
            saveSubscriberData();
            return addFreeProduct();
          }
          return Promise.resolve();
        })
        .then(function () {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = prevHtml;
          }
          
          // Actualizar URL de checkout con el descuento correcto
          var checkoutUrl = buildCheckoutUrl();
          var checkoutBtn = pop ? pop.querySelector('.lp-cart-pop__btn--primary') : null;
          if (checkoutBtn) checkoutBtn.href = checkoutUrl;
          
          openAddedPopup();
        })
        .catch(function () {
          // Fallback: submit normal
          try { 
            form.action = buildCheckoutUrl();
            form.submit(); 
          } catch (err) { 
            window.location.href = buildCheckoutUrl(); 
          }
        });
      });
    }

    // ========== INICIALIZACIÓN FINAL ==========
    updateAllPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();